import React from 'react';
import PropTypes from 'prop-types';
import {IntroSection, PlayerSection, NewsSection, TabSection} from '../../components';
import {connectToStores} from 'epic-alt-utils/index';
import {HomeStore, LoginStore, AppConfigStore, SubscriptionStore} from '../../stores';

@connectToStores
export default class HomeView extends React.PureComponent {
    static propTypes = {
        history: PropTypes.object,
        homeStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        loginStore: PropTypes.object,
        subscriptionStore: PropTypes.object
    };

    static getStores() {
        return [HomeStore, LoginStore, AppConfigStore, SubscriptionStore];
    }

    static getPropsFromStores() {
        return {
            homeStore: HomeStore.getState(),
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            subscriptionStore: SubscriptionStore.getState()
        };
    }

    render() {
        const {
            launchedCountries, unavailableCountries, isGameLaunched, isGameUnavailable, country
        } = this.props.appConfigStore;
        const {contentSection, recentBlogs, newsTitle} = this.props.homeStore;
        const introContent = this.props.homeStore.introSection;
        const {isLoggedIn} = this.props.loginStore;
        const {isSubscribed} = this.props.subscriptionStore;

        return (
            <div className="home" id="content">
                <section className="topBlock row no-mar-bot">
                    <IntroSection
                        history={this.props.history}
                        launchedCountries={launchedCountries}
                        unavailableCountries={unavailableCountries}
                        introContent={introContent}
                        isGameLaunched={isGameLaunched}
                        isGameUnavailable={isGameUnavailable}
                        isLoggedIn={isLoggedIn}
                        country={country}
                        isSubscribed={isSubscribed} />
                    <PlayerSection
                        introContent={introContent} />
                </section>
                <TabSection
                    contentSection={contentSection} />
                <NewsSection
                    recentBlogs={recentBlogs}
                    newsTitle={newsTitle} />
            </div>
        );
    }
}
